import { BaseComponent2 } from '../../_common/client/base-component2';
import { benefitEvents } from '@otto-ec/nexus-registry/benefit/events';

export type BenefitData = {
    active: boolean;
    id: string;
};

export class OffersPriceComponent extends BaseComponent2 {
    public rootSelector = '.js_of_offers-price';

    public async init(): Promise<void> {
        this.registerOnFT9BenefitEvent();
    }

    public async onReloadComponentEvent(): Promise<unknown> {
        return Promise.resolve(undefined);
    }

    private registerOnFT9BenefitEvent(): void {
        benefitEvents.active.subscribe(benefit => {
            const innerPriceElement = this.getChildElement('.js_of_offers-price__inner');
            if (!innerPriceElement) {
                throw new Error('can not select ".js_of_offers-price__inner"');
            }
            const benefitsElements = innerPriceElement.querySelectorAll<HTMLElement>('[data-benefit-id]');
            const priceElement = this.getChildElement('.of_offers-price__price');

            benefitsElements.forEach(element => {
                const benefitId = element.dataset.benefitId;
                if (benefitId === benefit.id && benefit.active) {
                    element.classList.remove('pl_hidden');
                    priceElement?.classList.add('pl_hidden');
                }
            });
        });
    }
}
